import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M6.178 8.547L11.694 3v18l-5.516-5.547H3.793c-.99 0-1.793-.81-1.793-1.81v-3.285a1.8 1.8 0 011.793-1.81h2.385z" }));
export default createSvgIcon(iconPath, "Low");
//# sourceMappingURL=VolumeLowIcon.js.map